
import React, { useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import * as handlers from "../../../../../../../../_redux/selected-user/selectedUserHandlers";


const CreateReserveAccountModal = props => {
  /* Redux State */
  const userBasic = useSelector(({selectedUser}) => selectedUser.data.profile.basic, shallowEqual);
  const [validated, setValidated] = useState(false);
  // Redux dispatch
  const dispatch = useDispatch();

  /* Form submission */
  const handleSubmit = e =>  {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    if (form.checkValidity() === true) {
      const formData = new FormData(form);
      props.setShowCreateReserveAccountModal(false);
      dispatch(handlers.createReserveAccount(props.match.params.userId, props.match.params.accountId, { meta: userBasic, ...Object.fromEntries(formData.entries())}));
    }
    setValidated(true);
  }
    
  return (
    <Modal
        show={props.showCreateReserveAccountModal}
        onHide={_ => props.setShowCreateReserveAccountModal(false)}
        aria-labelledby="contained-modal-title-vcenter"
        keyboard={false}
        onExited={_ => setValidated(false)}
      >
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
      >
        <Modal.Header >
          <Modal.Title id="contained-modal-title-vcenter">
          <i className="flaticon2-layers-2 text-primary mr-2"></i> Create New Reserve Account
          </Modal.Title>
          <button type="button" className="close" onClick={_ => props.setShowCreateReserveAccountModal(false)}>
              <span aria-hidden="true" className="d-block">×</span>
              <span className="sr-only">Close</span>
           </button>
        </Modal.Header>
        <Modal.Body>
            <Form.Group controlId="partnerId" className="px-5">
                <Form.Label >Gateway</Form.Label>
                <Form.Control
                    required
                    as="select"
                    className="mr-sm-2"
                    custom
                    name="gateway"
                >
                    <option value=""></option>
                    <option value="flutterwave">Flutterwave</option>
                    <option value="monnify">Monnify</option>
                    <option value="paystack">Paystack</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  Select Reserve Account Payment Gateway
                </Form.Control.Feedback>
            </Form.Group>
        </Modal.Body>
        <Modal.Footer>
            <button
                type="button"
                onClick={_=> props.setShowCreateReserveAccountModal(false)}
                className="btn btn-light btn-elevate px-4"
            >
                Cancel
            </button>
            <> </>
            <button
                type="submit"
                className="btn btn-primary btn-elevate px-4 ml-4"
            >
                Create
            </button>
        </Modal.Footer>
    </Form>
      </Modal>

        );
}

export default CreateReserveAccountModal;